import ResetPasswordMobile from './resetPasswordMobile'
export default ResetPasswordMobile
